<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--CERTIFICATION TRAINING PAGE-->
<ng-template [ngIf]="!isLoading">
  <section class="certification-pages margin-top-offset">
    <div class="wrapper">
      <!--INFORMATION BANNER-->
      <ng-container *ngIf="certificationAnnouncementContent; else unavailable">
        <app-information-banner
          [icon]="certificationAnnouncementContent?.acf?.icon_class"
          [bodyText]="certificationAnnouncementContent?.acf?.short_description | safe : 'html'"
          [actionLabel]="certificationAnnouncementContent?.acf?.cta_button_label"
          [customClass]="'margin-left-small margin-right-small'"
          [route]="
            certificationAnnouncementContent?.acf?.route_url
              ? certificationAnnouncementContent?.acf?.route_url
              : 'announcement/' + certificationAnnouncementContent.slug
          "
          [routeType]="routeTypes.INTERNAL"
          [display]="certificationAnnouncementContent?.acf?.display_notification">
        </app-information-banner>
      </ng-container>
      <!--END INFORMATION BANNER-->
      <!--CERTIFICATION BANNER-->
      <ng-container *ngIf="certificationBadgeAnnouncementContent">
        <app-information-banner
          [icon]="certificationBadgeAnnouncementContent?.acf?.icon_class"
          [bodyText]="certificationBadgeAnnouncementContent?.acf?.short_description | safe : 'html'"
          [actionLabel]="certificationBadgeAnnouncementContent?.acf?.cta_button_label"
          [customClass]="'margin-left-small margin-right-small'"
          [route]="'certification/claiming-your-digital-badge'"
          [routeType]="routeTypes.INTERNAL"
          [display]="certificationBadgeAnnouncementContent?.acf?.display_notification">
        </app-information-banner>
      </ng-container>
      <!--END CERTIFICATION BANNER-->

      <!--CERTIFICATION CONTENT-->
      <div class="columns">
        <!--LEFT SIDE CONTENT-->
        <ng-container *ngIf="certificationContent">
          <div class="left-aside-column">
            <!--SHARED CMS STATIC PAGE-->
            <app-static-page
              [title]="certificationContent.title"
              [bodyContent]="certificationContent.content | safe : 'html'">
            </app-static-page>
            <!--END SHARED CMS STATIC PAGE-->
          </div>
        </ng-container>
        <!--END LEFT SIDE CONTENT-->

        <!--RIGHT SIDE CONTENT-->
        <ng-container *ngIf="parentNavItems && parentNavItems.length > 0">
          <div class="right-aside-column">
            <app-aside-list-navigation
              [navItems]="parentNavItems"
              [childNavItems]="childNavItems"
              [slugname]="'certification'">
            </app-aside-list-navigation>
          </div>
        </ng-container>
        <!--END RIGHT SIDE CONTENT-->
      </div>
      <!--END CERTIFICATION CONTENT-->
    </div>
  </section>
</ng-template>
<!--END CERTIFICATION TRAINING PAGE-->
<ng-template #unavailable>
  <section>
    <p class="wrapper">
      Sorry for the inconvience. We are not able to load content at this time due to technical
      difficulties.
    </p>
  </section>
</ng-template>
